import { useEffect, useMemo, useState } from 'react'
import { useQuery } from "@apollo/client"
import { allBitkubActionsQuery, bitkubActionResolutionType, bitkubActionStrategyType, bitkubActionType, currencyToAllSignalActionsMapType } from 'src/types/bitkub-action-types'
import { ALL_BITKUB_ACTIONS, BITKUB_ACTIONS } from 'src/graphql/queries/bitkubAction'
import { bitkubBalanceType, bitkubPortfolioQuery } from 'src/types/balance-types'
import { BITKUB_BALANCE } from 'src/graphql/queries/balance'

interface hookProps {

}

const useAllBitkubActionsQuery = () => {
  const [currencyToAllSignalActionsMap,setCurrencyToAllSignalActionsMap] = useState<currencyToAllSignalActionsMapType>({});
  const { data:BitkubBalance } = useQuery<bitkubPortfolioQuery>(BITKUB_BALANCE)
  const {data, ...query} = useQuery<allBitkubActionsQuery>(ALL_BITKUB_ACTIONS)

  const balances = useMemo(()=>{
    if (BitkubBalance?.bitkubPortfolio?.__typename === "BitkubPortfolioOutput") {
      return BitkubBalance.bitkubPortfolio.balances
    }
  },[BitkubBalance])

  const response = useMemo(() => {
		const payload = data?.allBitkubActions
		if(payload?.__typename === "AllBitkubActionsOutPut") return payload.actions
    return []
	},[data])

  const responseError = useMemo(()=>{
    const payload = data?.allBitkubActions
		if(payload?.__typename === "Error") return payload
    return undefined
  },[data])

  const compare = (a:bitkubActionType,b:bitkubActionType) => {

    let aAction = a.action === undefined ? -3 : a.action
    let bAction = b.action === undefined ? -3 : b.action

    if (aAction < bAction) return 1
    if (aAction > bAction) return -1

    return 0


  }

  const getCurrency = (symbol:string) => {
    try {
      let symbolArr = symbol.split("_")
      if (symbolArr[0] === "THB") return symbolArr[1]
      if (symbolArr[1] === "THB") return symbolArr[0]
      return "UNK"
    } catch(_) {
      return "UNK"
    }
  }

  useEffect(()=>{
    let mapper:currencyToAllSignalActionsMapType = {}

    if (balances) {
      response.forEach((actionGroup,index)=>{
        let currentResolution = actionGroup.resolution
        let currentStrategy = actionGroup.strategyType
        let currentLength = index+1

        actionGroup.actions.forEach((action)=>{
          let currency = getCurrency(action.symbol)
          if (currency in mapper) {
            mapper[currency].push(action)
          } 
          else {
            mapper[currency] = [action]
          }
        })

        balances.forEach((balance)=>{
          let currency = balance.currency
          let placeHolderAction = {
            action:undefined,
            calculateAt:"",
            resolution:currentResolution,
            strategyType:currentStrategy,
            symbol:`${currency}_THB`
          }
          if (currency in mapper) {
            if (mapper[currency].length !== currentLength) {
              mapper[currency].push(placeHolderAction)
            }
          } else {
            mapper[currency] = [placeHolderAction]
          }
        })
      })
  
      Object.keys(mapper).map((key)=>{
        mapper[key] = mapper[key].sort(compare)
      })
  
      setCurrencyToAllSignalActionsMap(mapper)
    }
  },[response,balances])

  return {
    data:response,
    error:responseError,
    currencyToAllSignalActionsMap:currencyToAllSignalActionsMap,
    query,
  }
}

export default useAllBitkubActionsQuery